import React from "react";

function HistoricoGeral({ timeline }) {

    return (
        <div className="box-header">
            <h4 className="box-title" style={{ marginTop: 18 }}>
                <i className="fa fa-clock"></i> Histórico Geral
            </h4>
            <div
                className="container bootstrap snippets bootdeys center-element"
                style={{ marginTop: 30 }}
            >
                <div className="col-md-9">
                    <div className="timeline-centered timeline-sm">
                        {timeline.map((dados, index) => (
                            <article
                                key={dados.id}
                                className={`timeline-entry ${
                                    index % 2 === 0 ? "" : "left-aligned"
                                }`}
                            >
                                <div className="timeline-entry-inner">
                                    <time className="timeline-time">
                                        <span>{dados.hora}</span>
                                        <span>{dados.data}</span>
                                    </time>
                                    <div
                                        className={`timeline-icon ${dados.background}`}
                                    >
                                        <i className={`${dados.icon}`} />
                                    </div>
                                    <div
                                        className={`timeline-label ${dados.background}`}
                                    >
                                        <h4 className="timeline-title">
                                            {dados.usuario}
                                        </h4>
                                        <p>{dados.status}</p>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HistoricoGeral;
